import { Construtor } from './construtor';
import { CriterioAvaliacaoRotinaCliente } from './criterio-avaliacao-rotina-cliente';

export class CriterioReincidenciaOcorrencia implements Construtor<CriterioReincidenciaOcorrencia> {

    public idCriterioReincidenciaOcorrencia: number;
    public idReincidenciaOcorrencia: number;
    public idCriterioAvaliacaoRotinaCliente: number;
    public criterioAvaliacaoRotinaCliente: CriterioAvaliacaoRotinaCliente;
    public selecionado: boolean;
    public alterado: boolean;

    constructor(object?: any) {
        this.criterioAvaliacaoRotinaCliente = new CriterioAvaliacaoRotinaCliente();
        if (object !== undefined) {
            if (object instanceof (CriterioReincidenciaOcorrencia)) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    parseFromJson(criterio: any): void {
        this.idCriterioReincidenciaOcorrencia = criterio.idCriterioReincidenciaOcorrencia;
        this.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
        this.idReincidenciaOcorrencia = criterio.idReincidenciaOcorrencia;
        this.criterioAvaliacaoRotinaCliente = criterio.criterioAvaliacaoRotinaCliente;
    }

    copyObject(criterio: CriterioReincidenciaOcorrencia): void {
        this.idCriterioReincidenciaOcorrencia = criterio.idCriterioReincidenciaOcorrencia;
        this.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
        this.idReincidenciaOcorrencia = criterio.idReincidenciaOcorrencia;
        this.criterioAvaliacaoRotinaCliente = criterio.criterioAvaliacaoRotinaCliente;
    }

    modeloCompleto(): boolean {
        return this.idCriterioAvaliacaoRotinaCliente !== undefined && this.idReincidenciaOcorrencia !== undefined;
    }

    getNewInstance(object?: any): CriterioReincidenciaOcorrencia {
        return new CriterioReincidenciaOcorrencia(object);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/criterio-reincidencia-ocorrencia.ts